export enum UserRole {
    System_Admin = 1,
    Employee = 5,
    Enrollment_Assistant = 6
}